<template>
    <div class="ig-distribuicao-chart" ref="divChart">
        <apexchart :height="`${showBtn ? 'auto' : '180'}`" :ref="`igDistribuicao-${igId}`" type="bar" :options="chartOptions" :series="series"></apexchart>
    </div>
</template>

<script>
export default {
    name: 'DashboardIgDistribuicao',
    props: ['datas','showBtn'],
    data() {
        return {
            igId: null,
            series: [],
            chartOptions: {
                chart: {
                    events: {
                        updated: this.addSvgElements
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        distributed: true,
                        borderRadius: 1,
                        dataLabels: {
                            position: 'top',
                        },
                    },
                },
                xaxis: {
                    categories: ["Alto", "Moderado", "Baixo"],
                },
                yaxis: {
                    //max: 80,
                    tickAmount: 4,
                    labels: {
                        formatter: function (value) {
                            return value % 20 === 0 ? value : '';
                        },
                    },
                },
                tooltip: {
                    custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                        return (
                        '<span style="padding:5px"> Valor: ' + series[seriesIndex][dataPointIndex] + '</span>' +
                        '</div>'
                        );
                    },
                },
                legend: {
                    show: false,
                },
                colors: ["#b5f4d4", "#fff1bc", "#ffd6d6"],
                dataLabels: {
                    style: {
                        fontSize: '14px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: '400',
                        colors: ['#454545'],
                    },
                    offsetY: -5,
                    enabled: true,
                },
                title: {
                    text: 'Distribuição do IG',
                    floating: true,
                    offsetY: -6,
                    align: 'center',
                    style: {
                        color: '#2e2e2e',
                        fontWeight: '700'
                    }
                },
            }
        }
    },
    methods: {
      addSvgElements() {
        if (!this.$refs[`igDistribuicao-${this.igId}`]) return;

        const ref = this.$refs[`igDistribuicao-${this.igId}`];

        setTimeout(() => {
            const datalabels = ref.chart.el.querySelectorAll(".apexcharts-datalabel");

            // criar um elemento <tspan>
            const createTspan = (x, y, content, className) => {
                const tspan = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
                tspan.setAttribute("x", x);
                tspan.setAttribute("y", y);
                tspan.setAttribute("dy", "5");
                tspan.textContent = content;
                tspan.setAttribute("class", className);
                tspan.style.fontSize = "11px";
                return tspan;
            };

            // eterminar a cor da seta
            const determineArrowColor = (tipo, index) => {
              const isGreen = (index === 0 && tipo === 1) || (index === 1 && tipo === 0);
              const isRed = (index === 0 && tipo === 0) || (index === 1 && tipo === 1);

              if (isGreen) return "ig-arrow green";
              if (isRed) return "ig-arrow red";
              return "ig-arrow orange"; // Valor padrão
            };

            // criar e adicionar elementos SVG
            const appendSvgElements = (datalabel, index) => {
                if (index > 0) return; // Executar apenas para o primeiro item

                const x = parseFloat(datalabel.getAttribute("x"));
                const y = parseFloat(datalabel.getAttribute("y"));
                const variacao = this.datas.series[index].variacao;
                const tipo = this.datas.series[index].tipo;

                const numberTspan = createTspan(x + 30, y - 12, variacao, "ig-number");
                const arrowTspan = createTspan(
                    x + 21,
                    y - 7,
                    tipo === 1 ? "🠉" : tipo === 0 ? "🠋" : "●",
                    determineArrowColor(tipo, index)
                );

                datalabel.appendChild(arrowTspan);
                datalabel.appendChild(numberTspan);
            };

            datalabels.forEach(appendSvgElements);
        }, 200);
      },
      updateChart() {
        this.$nextTick(() => {

            this.series = [
                {
                    name:'Valor',
                    data: this.datas?.series.map(item => item.value)
                }
            ]

            
        })
      },
    },
    mounted() {
      this.updateChart();
    },
    created() {
      this.igId = this.generateSecureId();
    },
}
</script>
<style lang="scss">
    .ig-distribuicao-chart {
        text-align:Center;
        position: relative;
    }
    .ig-arrow {
        fill: #0f0;
        &.green {
            fill:#00cc66;
        }
        &.red {
            fill:#FF3033;
        }
    }
</style>
